import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeItemCreate,
  detail: routeItemDetail,
  home: routeItemsHome,
  root: routeItemsRoot,
} = createDoctypeRoutes({
  createName: 'new-item',
  createPath: 'new-item',
  detailName: 'itemDetail',
  doctype: DOCTYPES.ITEM,
  homeName: 'items',
  path: 'items',
  views: {
    create: async () => await import('@/components/viewsExternal/items/AddItem.vue'),
    detail: async () => await import('@/components/viewsExternal/items/ViewItem.vue'),
    list: async () => await import('@/components/viewsExternal/itemsModule/ViewItems.vue'),
  },
})

export { routeItemCreate, routeItemDetail, routeItemsHome, routeItemsRoot }
